<!-- @format -->

<!-- TODO: remove trapFocus and restoreFocus() and fix focus trap in homefield -->
<ng-template #reviewModalTemplate>
	<product-reviews-review-section class="review-section"></product-reviews-review-section>
</ng-template>
